import { defineComponent as _defineComponent } from 'vue'
import {WebChargeStatus} from "@/Enums";
import {useI18n} from "@/composables/useI18n";
import {computed, PropType} from "vue";
import moment from "moment/moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebchargeStateChip',
  props: {
  webchargeState: {
    required: true,
    type: String as PropType<WebChargeStatus>,
  },
  chargeDate: {
    required: false,
    type: String as PropType<string | undefined>,
  },
},
  setup(__props) {

const props = __props;

const {
  t
} = useI18n();



const getStatusText = (state: WebChargeStatus) => statusText.value[state] ?? t('webcharge_state.unknown');

const statusText = computed(() => {
  return {
    [WebChargeStatus.All]: t('webcharge_state.unknown'),
    [WebChargeStatus.Success]: t("webcharge_state.success"),
    [WebChargeStatus.Unknown]: t('webcharge_state.unknown'),
    [WebChargeStatus.MaxChargeLimitError]: t("webcharge_state.max_charge_limit_error"),
    [WebChargeStatus.ConfigurationError]: t("webcharge_state.configuration_error"),
    [WebChargeStatus.MaxCardLimitError]: t("webcharge_state.max_card_limit_error"),
    [WebChargeStatus.SystemError]: t("webcharge_state.system_error"),
    [WebChargeStatus.MinCardLimitError]: t("webcharge_state.min_card_limit_error"),
    [WebChargeStatus.WebchargeDisabled]: t("webcharge_state.webcharge_disabled"),
  }
})

return { __sfc: true,t, props, getStatusText, statusText, WebChargeStatus, moment }
}

})